import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell, IconCell, TableColumnCell } from '@components/common';
import Actions from '@components/common/Actions';

import { optionsFormattedWithIdName } from '@utils/formatter';

import { TAssignmentUnit } from '@interfaces/organisation/assignApprovalUnits';
import { IApprovalUnit } from '../ManageApprovalUnits/interfaces';

import { columnSizes } from '@constants/table';

export const getColumns = ({
	toggleDeleteModal,
	toggleEditModal,
	setEditAssignment,
	setDeleteAssignmentId,
}: {
	toggleDeleteModal: () => void;
	toggleEditModal: () => void;
	setEditAssignment: React.Dispatch<React.SetStateAction<TAssignmentUnit | null>>;
	setDeleteAssignmentId: React.Dispatch<React.SetStateAction<string | null>>;
}) => ([
	{
		header: 'Asset Type',
		accessorKey: 'assetType',
		size: columnSizes.size200,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return (
				<IconCell
					id={value?.icon?.id}
					text={value?.assetTypeName}
				/>
			);
		},
	},
	{
		header: 'Asset Subtype',
		accessorKey: 'assetSubType',
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value?.assetSubTypeName} />;
		},
	},
	{
		header: 'Approval Units',
		accessorKey: 'units',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return <TableColumnCell textList={value?.map((unit: IApprovalUnit) => unit.name)} />;
		},
	},
	{
		header: 'Count',
		accessorKey: 'count',
		enableSorting: false,
		cell: ({ row }: CellContext<any, any>) => {
			return <AdaptiveTableCell text={row?.original?.units?.length} />;
		},
	},
	{
		header: 'Actions',
		accessorKey: 'actions',
		size: columnSizes.size85,
		enableSorting: false,
		cell: ({ row }: CellContext<any, any>) => {
			const handleDelete = () => {
				setDeleteAssignmentId(row?.original?.id);
				toggleDeleteModal();
			};

			const handleEdit = () => {
				const { assetType, assetSubType, units, id } = row?.original || {};
				const unitIds = units?.map((unit: IApprovalUnit) => ({ id: unit?.id, name: unit?.name }));

				setEditAssignment({
					id,
					assetType: assetType,
					assetSubType: assetSubType,
					unitIds: optionsFormattedWithIdName(unitIds),
				});
				toggleEditModal();
			};

			return (
				<Actions
					clearHandler={handleDelete}
					clearTooltip='Remove all Approval units'
					editHandler={handleEdit}
					editTooltip='Edit Approval units'
					isClear
					isEdit
				/>
			);
		},
	},
]);
